import React from "react";
import { Field, Input, Textarea, SectionTitle, Card } from "./_shared";
import { X, Plus } from "lucide-react";

function PanelEditor({ label, value, onChange, accent }) {
  const setField = (k, v) => onChange({ ...value, [k]: v });
  const setTag = (i, v) => {
    const tags = [...value.tags]; tags[i] = v;
    onChange({ ...value, tags });
  };
  const addTag = () => onChange({ ...value, tags: [...value.tags, "Nuevo tag"] });
  const removeTag = (i) => onChange({ ...value, tags: value.tags.filter((_, idx) => idx !== i) });

  return (
    <Card>
      <div className="flex items-center gap-2 mb-4">
        <span className="w-2.5 h-2.5 rounded-full" style={{ background: accent }} />
        <h3 className="font-display text-xl">{label}</h3>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <Field label="Unidad (etiqueta)"><Input value={value.unidad} onChange={(e) => setField("unidad", e.target.value)} /></Field>
        <Field label="Imagen (URL)"><Input value={value.image} onChange={(e) => setField("image", e.target.value)} /></Field>
        <Field label="Título línea 1"><Input value={value.title_line1} onChange={(e) => setField("title_line1", e.target.value)} /></Field>
        <Field label="Título línea 2"><Input value={value.title_line2} onChange={(e) => setField("title_line2", e.target.value)} /></Field>
        <div className="md:col-span-2">
          <Field label="Descripción"><Textarea rows={3} value={value.description} onChange={(e) => setField("description", e.target.value)} /></Field>
        </div>
        <Field label="CTA · Texto"><Input value={value.cta_label} onChange={(e) => setField("cta_label", e.target.value)} /></Field>
        <Field label="CTA · Link"><Input value={value.cta_link} onChange={(e) => setField("cta_link", e.target.value)} /></Field>
      </div>
      <div className="mt-5">
        <div className="flex items-center justify-between mb-2">
          <label className="font-mono-caps text-xs tracking-[0.3em] uppercase text-white/50">Tags</label>
          <button onClick={addTag} className="inline-flex items-center gap-1 text-xs text-white/60 hover:text-white transition-colors">
            <Plus className="w-3 h-3" /> Añadir
          </button>
        </div>
        <div className="space-y-2">
          {value.tags.map((t, i) => (
            <div key={i} className="flex gap-2">
              <Input value={t} onChange={(e) => setTag(i, e.target.value)} />
              <button onClick={() => removeTag(i)} className="w-10 h-10 rounded-lg border border-white/10 hover:border-red-500/40 text-white/50 hover:text-red-400 flex items-center justify-center transition-colors">
                <X className="w-4 h-4" />
              </button>
            </div>
          ))}
        </div>
      </div>
    </Card>
  );
}

export default function HeroEditor({ value, onChange }) {
  return (
    <div>
      <SectionTitle title="Hero (Portada)" subtitle="Dos paneles de la pantalla principal" />
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <PanelEditor label="KILOMBO MUSIC" value={value.music} onChange={(v) => onChange({ ...value, music: v })} accent="#ff6a2b" />
        <PanelEditor label="KILOMBO TEAMS" value={value.teams} onChange={(v) => onChange({ ...value, teams: v })} accent="#2ec9a8" />
      </div>
    </div>
  );
}
